export default __webpack_public_path__ + "static/media/4.30cbfd76.png";